import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import SocialLinks from "../SocialLinks";

const centerTextStyle = { textAlign: "center" };
const headingStyle = { paddingBottom: 15 };
const typeContainerStyle = { padding: 50, textAlign: "center" };
const socialRowStyle = { paddingTop: "50px", paddingBottom: "80px" };

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={12} className="home-header" style={centerTextStyle}>
              <h1 style={headingStyle} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Dheeraj Jain</strong>
              </h1>

              <div className="type-container" style={typeContainerStyle}>
                <Type />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />

      <Container>
        <Row style={socialRowStyle}>
          <Col md={12} className="home-about-social">
            <h1 style={centerTextStyle}>Find Me On</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <SocialLinks
              className="home-about-social-links"
              iconClassName="icon-colour home-social-icons"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default React.memo(Home);
